// Supported file formats for different processing types
// Based on what our AI models (Gemini) and processing pipelines support

export const SUPPORTED_IMAGE_FORMATS = [
  'image/png',
  'image/jpeg',
  'image/jpg', // Some browsers may report this
  'image/webp',
  'image/heic',
  'image/heif'
] as const;

// Future document formats (not yet implemented)
export const SUPPORTED_DOCUMENT_FORMATS = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain'
] as const;

// Organized by processing type
export const SUPPORTED_FORMATS = {
  images: SUPPORTED_IMAGE_FORMATS,
  documents: SUPPORTED_DOCUMENT_FORMATS
} as const;

export type SupportedFormatType = keyof typeof SUPPORTED_FORMATS;

/**
 * Determines what type of files are being dragged
 * @param mimeTypes Array of MIME types from drag event
 * @returns The format type ('images', 'documents') or 'unsupported'
 */
export function detectDragContentType(mimeTypes: string[]): SupportedFormatType | 'unsupported' {
  // Check images first
  if (mimeTypes.some(mimeType => SUPPORTED_IMAGE_FORMATS.includes(mimeType as any))) {
    return 'images';
  }

  // Check documents
  if (mimeTypes.some(mimeType => SUPPORTED_DOCUMENT_FORMATS.includes(mimeType as any))) {
    return 'documents';
  }

  return 'unsupported';
}

/**
 * Checks if a specific MIME type is supported for image processing
 * @param mimeType The MIME type to check
 * @returns Whether the MIME type is supported for images
 */
export function isImageMimeTypeSupported(mimeType: string): boolean {
  return SUPPORTED_IMAGE_FORMATS.includes(mimeType as any);
}
